module.exports = __webpack_public_path__ + "fonts/AdelleSAGE.2ff9fa8d.eot";